import { useEffect, useRef } from 'react';

/** CSS var read by SuperConnectorLayout so fixed bottom banners never cover content. */
export const BOTTOM_BANNER_HEIGHT_VAR = '--sc-bottom-banner-height';

/**
 * Attach to a fixed bottom banner root. Publishes its measured height (plus a
 * small gap) so the main scroll area can pad underneath on mobile wrap layouts.
 */
export function useReportBottomBannerHeight(extraGapPx = 8) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const apply = () => {
      const height = Math.ceil(el.getBoundingClientRect().height) + extraGapPx;
      document.documentElement.style.setProperty(BOTTOM_BANNER_HEIGHT_VAR, `${height}px`);
    };
    apply();

    const ro = new ResizeObserver(apply);
    ro.observe(el);
    window.addEventListener('resize', apply);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', apply);
      document.documentElement.style.setProperty(BOTTOM_BANNER_HEIGHT_VAR, '0px');
    };
  }, [extraGapPx]);

  return ref;
}
